/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-grid-system'
import PropTypes from 'prop-types'
import { MdStore } from 'react-icons/md'
import { useSelector } from 'react-redux'
import routes from '../../../config/routes'
import { formatCNPJ } from '../../../lib/format'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Card from '../../commons/Card/Card'
import Flex from '../../commons/Flex/Flex'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import Thumbnail from '../../commons/Thumbnail/Thumbnail'
import styles from './peoplePersonCompany.module.scss'

const GRADIENT = 99

const PeoplePersonCompany = ({
  match: {
    params: { id }
  }
}) => {
  const [breadcrumbs, setBreadcrumbs] = useState([
    {
      id: 1,
      title: 'Pessoas',
      path: routes.people.list.path
    }
  ])
  const detail = useSelector((store) => store.supervisedReducer.detail)

  useEffect(() => {
    setBreadcrumbs([
      ...breadcrumbs,
      {
        id: 2,
        title: 'Detalhes',
        path: routes.people.detail.generate(id)
      },
      {
        id: 3,
        title: 'Empresa'
      }
    ])
  }, [id])

  return (
    <DefaultLayout>
      {detail && (
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Text color="gray" size="lg" variation="dark" extraBold>
                Dados da Empresa
              </Text>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Breadcrumb items={breadcrumbs} />
            </Col>
          </Row>

          <Row>
            <Col sm={12} md={12} lg={6}>
              <Card className={styles.card}>
                <Flex column>
                  <Thumbnail type={GRADIENT}>
                    <MdStore size={25} />
                  </Thumbnail>
                  <Text
                    color="gray"
                    variation="dark"
                    size="md"
                    bold
                    margin="10px 0px 0px 0px"
                  >
                    Dados da Empresa
                  </Text>
                  <Text
                    color="gray"
                    variation="light"
                    size="xs"
                    margin="10px 0px 0px 0px"
                    font="custom"
                  >
                    Veja os dados de CNPJ
                  </Text>
                </Flex>
              </Card>
            </Col>
            <Col sm={12} md={12} lg={6}>
              <Card className={styles.card}>
                <Text margin="26px 0px" color="gray" variation="dark" bold>
                  Empresa
                </Text>
                <Text size="xs" color="gray" variation="dark" font="custom">
                  {detail.name}
                </Text>
                <div className={styles.divider} />

                <Text margin="26px 0px" color="gray" variation="dark" bold>
                  CNPJ
                </Text>
                <Text size="xs" color="gray" variation="dark" font="custom">
                  {formatCNPJ(detail.cnpj)}
                </Text>
              </Card>
            </Col>
          </Row>
        </Container>
      )}
    </DefaultLayout>
  )
}

PeoplePersonCompany.defaultProps = {
  match: {
    params: {}
  }
}

PeoplePersonCompany.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  })
}
export default PeoplePersonCompany
